export default __webpack_public_path__ + "static/media/private-estate-img.9e941761.svg";